<div id="dashboard-project" class="page-layout simple right-sidebar" fxLayout="row">
        
    <!-- CENTER -->
    <div class="center" fusePerfectScrollbar>

        <!-- HEADER -->
        <div class="header accent p-24 pb-0" fxLayout="column" fxLayoutAlign="space-between">
            <div fxLayout="row" fxLayoutAlign="space-between start">
                <span 
                    class="mat-display-1 my-0 my-sm-24 welcome-message"
                    [@animate]="{value:'*',params:{x:'50px'}}">Parâmetro do Sistema
                </span>
                <span class="mat-display-1 my-0 my-sm-24 welcome-message" >
                    <button 
                        mat-mini-fab
                        matTooltip = "Salvar"
                        color="green"
                        class="save-product-button"                    
                        (click)="salvar()">
                        <mat-icon>save</mat-icon>
                    </button>
                </span>
            </div>
        </div>
        <!-- / HEADER -->

        <!-- CONTENT -->
        <div class="content">
            <form name="productForm" class="product w-100-p" fxLayout="column" fxFlex>
                <mat-tab-group>                    
                        <mat-tab label="Boletas">
                            <mat-card>
                                <mat-card-header>
                                    <mat-card-title>Configuração das Boletas</mat-card-title>
                                </mat-card-header>
                                <mat-card-content>
                                    <div class="tab-content p-24" fusePerfectScrollbar fxLayout="column">
                                        <div fxLayout="row" fxLayoutAlign="space-between">
                                            <mat-form-field appearance="outline" floatLabel="always" fxFlex="49">
                                                <mat-label>Valor Mínimo Primeira Boleta Swing Trade</mat-label>
                                                <input 
                                                    matInput 
                                                    placeholder="R$ 20.000,00" 
                                                    [formControl]="vlr_min_boleta_sw" 
                                                    name="vlr_min_boleta_sw"                                            
                                                    maxlength="20"
                                                    currencyMask 
                                                    [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }">                                        
                                            </mat-form-field>
        
                                            <mat-form-field appearance="outline" floatLabel="always" fxFlex="49">
                                                <mat-label>Valor Mínimo Boleta Swing Trade</mat-label>
                                                <input 
                                                    matInput 
                                                    placeholder="R$ 20.000,00" 
                                                    [formControl]="vlr_min_primeira_boleta_sw" 
                                                    name="vlr_min_primeira_boleta_sw"                                            
                                                    maxlength="20"
                                                    currencyMask 
                                                    [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }">                                        
                                            </mat-form-field>
                                        </div>

                                        <div fxLayout="row" fxLayoutAlign="space-between">
                                            <mat-form-field appearance="outline" floatLabel="always" fxFlex="49">
                                                <mat-label>Valor Mínimo Primeira Boleta Financiamento de Opções</mat-label>
                                                <input 
                                                    matInput 
                                                    placeholder="R$ 20.000,00" 
                                                    [formControl]="vlr_min_boleta_fop" 
                                                    name="vlr_min_boleta_fop"                                            
                                                    maxlength="15"
                                                    currencyMask 
                                                    [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }">                                        
                                            </mat-form-field>
        
                                            <mat-form-field appearance="outline" floatLabel="always" fxFlex="49">
                                                <mat-label>Valor Mínimo Boleta Financiamento de Opções</mat-label>
                                                <input 
                                                    matInput 
                                                    placeholder="R$ 20.000,00" 
                                                    [formControl]="vlr_min_primeira_boleta_fop" 
                                                    name="vlr_min_primeira_boleta_fop"                                            
                                                    maxlength="15"
                                                    currencyMask 
                                                    [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }">                                        
                                            </mat-form-field>
                                        </div>
                                    </div>                                
                                </mat-card-content>
                            </mat-card>
                        </mat-tab>

                        <mat-tab label="Notificação">
                            <mat-card>
                                <mat-card-header>
                                    <mat-card-title>Configuração das Notificações</mat-card-title>
                                </mat-card-header>
                                <mat-card-content>
                                    <div class="tab-content p-24" fusePerfectScrollbar fxLayout="column">
                                        <div fxLayout="row" fxLayoutAlign="space-between">
                                            <mat-form-field appearance="outline" floatLabel="always" fxFlex="49">
                                                <mat-label>Texto da Notificação que sócios recebem quando tem operação</mat-label>
                                                <textarea 
                                                    matInput 
                                                    cdkTextareaAutosize
                                                    #autosize="cdkTextareaAutosize"
                                                    cdkAutosizeMinRows="5"                                                    
                                                    [formControl]="texto_notificacao_operacao" 
                                                    name="texto_notificacao_operacao"></textarea>
                                            </mat-form-field>

                                            <mat-form-field appearance="outline" floatLabel="always" fxFlex="49">
                                                <mat-label>Texto padrão da notificação informativo</mat-label>
                                                <textarea 
                                                    matInput 
                                                    cdkTextareaAutosize
                                                    #autosize="cdkTextareaAutosize"
                                                    cdkAutosizeMinRows="5"                                                    
                                                    [formControl]="texto_notificacao_operacao_informativo" 
                                                    name="texto_notificacao_operacao_informativo"></textarea>
                                            </mat-form-field>
                                        </div>                                       
                                    </div>                                
                                </mat-card-content>
                            </mat-card>
                        </mat-tab>                        
                        
                        <mat-tab label="Renda Variável">
                            <mat-card>
                                <mat-card-header>
                                    <mat-card-title>Configurações</mat-card-title>
                                </mat-card-header>
                                <mat-card-content>
                                    <div class="tab-content p-24" fusePerfectScrollbar fxLayout="column">
                                        <div fxLayout="row" fxLayoutAlign="space-between">
                                            <mat-form-field appearance="outline" floatLabel="always" fxFlex="49">
                                                <mat-label>Percentual Máximo Custódia Carteira Ativo</mat-label>
                                                <input 
                                                    matInput 
                                                    placeholder="100%" 
                                                    [formControl]="percentual_max_custodia" 
                                                    name="percentual_max_custodia"                                            
                                                    maxlength="20"
                                                    currencyMask 
                                                    [options]="{ prefix: ' ', suffix: ' %' , thousands: '.', decimal: ',' }">                               
                                            </mat-form-field>

                                            <mat-form-field appearance="outline" floatLabel="always" fxFlex="49">
                                                <mat-label>Percentual Máximo Custódia Carteira Setor</mat-label>
                                                <input 
                                                    matInput 
                                                    placeholder="100%" 
                                                    [formControl]="percentual_max_custodia_setor"
                                                    name="percentual_max_custodia_setor"
                                                    maxlength="20"
                                                    currencyMask 
                                                    [options]="{ prefix: ' ', suffix: ' %' , thousands: '.', decimal: ',' }">                               
                                            </mat-form-field>
                                        </div>

                                        <div fxLayout="row" fxLayoutAlign="space-between">
                                            <mat-form-field appearance="outline" floatLabel="always" fxFlex="49">
                                                <mat-label>Percentual Marcação Mercado dos Ativo Gerador Ordens</mat-label>
                                                <input 
                                                    matInput 
                                                    placeholder="100%" 
                                                    [formControl]="percentual_marcao_mercado_rv" 
                                                    name="pertual_min_sinte"                                            
                                                    maxlength="7"
                                                    currencyMask 
                                                    [options]="{ prefix: ' ', suffix: ' %' , thousands: '.', decimal: ',' }">
                                            </mat-form-field>

                                            <mat-form-field appearance="outline" floatLabel="always" fxFlex="49">
                                                <mat-label>Valor Minimo para Dividir os Ativos no Gerador De Ordens </mat-label>
                                                <input 
                                                    matInput 
                                                    placeholder="100%" 
                                                    [formControl]="vlr_minimo_divisao_ativo_rv" 
                                                    name="pertual_min_sinte"
                                                    maxlength="9"
                                                    currencyMask 
                                                    [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"
                                                >
                                            </mat-form-field>
                                        </div>

                                        <div fxLayout="row" fxLayoutAlign="space-between">
                                            <mat-form-field appearance="outline" floatLabel="always" fxFlex="49">
                                                <mat-label>Percentual Mínimo Para Sintético</mat-label>
                                                <input 
                                                    matInput 
                                                    placeholder="100%" 
                                                    [formControl]="pertual_min_sinte" 
                                                    name="pertual_min_sinte"                                            
                                                    maxlength="9"
                                                    currencyMask 
                                                    [options]="{ prefix: ' ', suffix: ' %' , thousands: '.', decimal: ',' }">
                                            </mat-form-field>
                                        </div>
                                    </div>                                
                                </mat-card-content>
                            </mat-card>
                        </mat-tab>

                        <!-- PROSP-594: janela de inatividade da sessao. Visivel/editavel
                             apenas para quem tem a permissao "Configurar Tempo de Sessao"
                             (o backend reforca no PUT). -->
                        <mat-tab *ngIf="podeConfigurarSessao" label="Sessão">
                            <mat-card>
                                <mat-card-header>
                                    <mat-card-title>Segurança da Sessão</mat-card-title>
                                </mat-card-header>
                                <mat-card-content>
                                    <div class="tab-content p-24" fusePerfectScrollbar fxLayout="column">
                                        <div fxLayout="row" fxLayoutAlign="space-between center">
                                            <mat-form-field appearance="outline" floatLabel="always" fxFlex="49">
                                                <mat-label>Tempo de inatividade (minutos)</mat-label>
                                                <input
                                                    matInput
                                                    type="number"
                                                    min="5"
                                                    max="1440"
                                                    step="1"
                                                    placeholder="240"
                                                    [formControl]="idle_timeout_minutes"
                                                    name="idle_timeout_minutes">
                                                <mat-hint>Entre 5 e 1440 minutos (24h). Padrão: 240 (4h).</mat-hint>
                                            </mat-form-field>

                                            <button
                                                mat-raised-button
                                                color="accent"
                                                (click)="salvarSessao()">
                                                Salvar tempo de inatividade
                                            </button>
                                        </div>
                                    </div>
                                </mat-card-content>
                            </mat-card>
                        </mat-tab>

                </mat-tab-group>
            </form>
        </div>
    </div>
</div>